export function Footer() {
  return (
    <footer className="mt-auto pt-8 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-6 border-t border-text-inverse/20">
          {/* gut8 Corporate Design v2 - Footer */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Logo and Company */}
            <a
              href="https://wertweisend.net"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 hover:opacity-80 transition-opacity"
            >
              <img
                src="/images/gut8_logo-full.svg"
                alt="gut8 GmbH - Wertweisend"
                className="h-10 w-auto"
              />
            </a>

            {/* Links */}
            <div className="flex flex-wrap items-center justify-center gap-4 text-gut8-sm">
              <a
                href="https://wertweisend.net/impressum-kontakt/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-medium hover:text-secondary transition-colors"
              >
                Impressum & Kontakt
              </a>
              <span className="hidden md:inline text-text-inverse/40">|</span>
              <a
                href="https://wertweisend.net/datenschutz/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-medium hover:text-secondary transition-colors"
              >
                Datenschutz
              </a>
              <span className="hidden md:inline text-text-inverse/40">|</span>
              <span className="text-text-inverse/60">Powered by OpenStreetMap</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
